import React from "react";
import PropTypes from "prop-types"

import "../become-member/become-member.sass"

const BecomeMember = ({children}) => {

    return (
        <div
            className={'become-member section'}
        >
            <div className={'text-container'}>
                <h3>Sie betreiben ein Gewerbe in Erdmannhausen?</h3>
                <p>Sie wollen auch in Zukunft von einer lebendigen Gemeinde profitieren? Sie möchten sich mit Ideen und
                    Einsatz für unseren Standort einbringen oder einfach nur den Verein unterstützen? Dann werden Sie
                    Mitglied!</p>
                <a className={'button'} href="/beitreten">MITGLIED WERDEN</a>
            </div>
        </div>
    )
};

BecomeMember.propTypes = {
    children: PropTypes.node,
};

export default BecomeMember
